/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TetraDto } from '../../models/tetra-dto';

export interface ApiTetraInformativaGet$Params {
    /**
     * data di inizio - date
     */
    da: number;

    /**
     * data di fine - date
     */
    a: number;
}

export function apiTetraInformativaGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiTetraInformativaGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<TetraDto>>> {
    const rb = new RequestBuilder(rootUrl, apiTetraInformativaGet.PATH, 'get');
    if (params) {
        rb.query('da', params.da, {});
        rb.query('a', params.a, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<TetraDto>>;
        }),
    );
}

apiTetraInformativaGet.PATH = '/api/tetra/informativa';
